// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {Basic_select, i_basic_select_props, i_render_body_props,
    i_render_option_props} from './basic_select';
import {get_config} from './select_config';

export interface i_select_props extends Omit<i_basic_select_props,
    'render_body' | 'render_option'> {
    label?: string | React.ReactNode;
    selected_icon?: JSX.Element;
    dropdown_icon?: JSX.Element;
    placeholder: string | React.ReactNode;
    render_body?: (props: i_render_body_props)=>React.ReactNode;
    render_option?: (props: i_render_option_props)=>React.ReactNode;
}

export const Select = (props: i_select_props)=>{
    const {
        placeholder,
        label,
        options,
        selected_icon,
        dropdown_icon,
        render_body,
        render_option,
        ...rest_props
    } = props;
    const default_render_body = ({selected, value}: i_render_body_props)=>{
        const text =()=>{
            if (!selected || value === null || value === '')
                return placeholder;
            return options.find(opt=>opt.value === value)?.label || '';
        };
        const icon = dropdown_icon || get_config().dropdown_icon;
        return <>
          {text()}
          <span data-elem="dropdown_icon">{icon}</span>
        </>;
    };
    const default_render_option = ({option, selected}: i_render_option_props)=>
        {
        const icon = selected ? selected_icon || get_config().selected_icon
            : null;
        return <>
          {option.label}
          <span data-elem="selected_icon">{icon}</span>
        </>;
    };
    const render_label = ()=>label;
    return <Basic_select
      options={options}
      render_body={render_body || default_render_body}
      render_option={render_option || default_render_option}
      render_label={label ? render_label : undefined}
      {...rest_props}
    />;
};
